module.exports = __webpack_public_path__ + "static/media/notebook-05.0aad59b4.png";